import { AuditCard } from "@/pages/a7/Audit/AuditCard";
import i18n from "@/i18n";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { A7OPCVMUnderlyingTSEditCard } from "./edit_card";

import { getUnderlyingTsAuditColumns } from "./columns";

const table_name = "a7_opcvm_underlying_ts";

export const A7OPCVMUnderlyingTSEdit = () => {
  const { id } = useParams<{ id: string }>();
  const { t, i18n: i18nClient } = useTranslation(["tables", "common"]);
  const auditColumns = useMemo(
    () => getUnderlyingTsAuditColumns(t),
    [t, i18nClient.language],
  );

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="h-full bg-gray-50">
      <div className="flex flex-col gap-10 p-10">
        <A7OPCVMUnderlyingTSEditCard id={Number(id)} />
        <AuditCard
          id={Number(id)}
          name={table_name}
          audit_columns={auditColumns}
          client="a7"
        />
      </div>
    </div>
  );
};
